module.exports = __webpack_public_path__ + "img/ac-logotipo.3216a0a5.svg";